import { supabase } from './supabase'

/**
 * Get all versions of a medical history
 */
export const getMedicalHistoryVersions = async (medicalHistoryId, organizationId) => {
  try {
    const { data, error } = await supabase
      .from('medical_history_versions')
      .select('*, changed_by_user:changed_by(email, raw_user_meta_data)')
      .eq('medical_history_id', medicalHistoryId)
      .eq('organization_id', organizationId)
      .order('version_number', { ascending: false })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching history versions:', error)
    throw error
  }
}

/**
 * Get specific version
 */
export const getMedicalHistoryVersion = async (versionId) => {
  try {
    const { data, error } = await supabase
      .from('medical_history_versions')
      .select('*')
      .eq('id', versionId)
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error fetching version:', error)
    throw error
  }
}

